import { cn } from "@/lib/utils";
import Breadcrumbs from "./Breadcrumbs";

interface MinimalHeroProps {
  title: string;
  breadcrumb?: { label: string; href?: string }[];
  variant?: "light" | "dark";
}

const MinimalHero = ({ title, breadcrumb, variant = "light" }: MinimalHeroProps) => {
  const isDark = variant === "dark";

  return (
    <section
      className={cn(
        "pt-36 pb-14 md:pt-44 md:pb-20",
        isDark ? "bg-secondary on-dark" : "bg-background border-b border-border"
      )}
    >
      <div className="mx-auto max-w-content px-5 md:px-12">
        {breadcrumb && (
          <div className="mb-4">
            <Breadcrumbs items={breadcrumb} />
          </div>
        )}
        <h1
          className={cn(
            "font-headline text-4xl sm:text-5xl md:text-6xl leading-tight",
            "text-foreground"
          )}
        >
          {title}
        </h1>
      </div>
    </section>
  );
};

export default MinimalHero;
